import React from 'react';
import { useSimulationStore } from '@/store/useSimulationStore';
import { useUIStore } from '@/store/useUIStore';
import { AgentRosterItem } from './AgentRosterItem';

export const AgentRoster: React.FC = () => {
  const agents = useSimulationStore(s => s.agents);
  const { selectedAgentId, selectAgent } = useUIStore();

  const online = agents.filter(a => a.online);
  const offline = agents.filter(a => !a.online);

  return (
    <aside className="flex flex-col bg-bg-panel border-b md:border-b-0 md:border-r border-bg-border w-full md:w-[240px] flex-shrink-0 max-h-[38vh] md:max-h-none md:h-full">
      {/* Header */}
      <div className="px-3 py-2 border-b border-bg-border">
        <div className="flex items-center justify-between">
          <span className="font-pixel text-xs text-gray-400">AGENTS</span>
          <span className="font-mono text-xs text-neon-green">{online.length} ACTIFS</span>
        </div>
      </div>

      {/* Liste */}
      <div className="flex-1 overflow-y-auto scrollbar-thin py-1 px-1 space-y-0.5">
        {online.map(agent => (
          <AgentRosterItem
            key={agent.id}
            agent={agent}
            selected={selectedAgentId === agent.id}
            onClick={() => selectAgent(selectedAgentId === agent.id ? null : agent.id)}
          />
        ))}

        {offline.length > 0 && (
          <>
            <div className="px-2 py-1 mt-2">
              <span className="font-mono text-xs text-gray-600 uppercase">Hors ligne</span>
            </div>
            {offline.map(agent => (
              <AgentRosterItem
                key={agent.id}
                agent={agent}
                selected={selectedAgentId === agent.id}
                onClick={() => selectAgent(selectedAgentId === agent.id ? null : agent.id)}
              />
            ))}
          </>
        )}
      </div>

      {/* Footer — résumé */}
      <div className="px-3 py-2 border-t border-bg-border">
        <div className="font-mono text-xs text-gray-600">
          Efficacité moy. : <span className="text-neon-green">
            {Math.round(online.reduce((s, a) => s + a.stats.efficiency, 0) / (online.length || 1))}%
          </span>
        </div>
      </div>
    </aside>
  );
};
